import { createSlice } from '@reduxjs/toolkit';
import { Friend } from '@/core/interfaces';

interface FriendsState {
	friends: Friend[];
	friendsAmount: number;
}

const friendsSlice = createSlice({
	name: 'friends',
	initialState: {
		friends: [],
		friendsAmount: 0,
	} as FriendsState,
	reducers: {
		setFriends: (state, action) => {
			state.friends = action.payload;
		},
		setAmountFriends: (state, action) => {
			state.friendsAmount = action.payload;
		},
	},
});

const { reducer, actions } = friendsSlice;

export const { setFriends, setAmountFriends } = actions;
export default reducer;
